import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={10}
      height={9}
      viewBox="0 0 10 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M9.375 1.25H8.01A1.87 1.87 0 006.25 0a1.87 1.87 0 00-1.76 1.25H.625a.625.625 0 000 1.25H4.49a1.87 1.87 0 001.76 1.25A1.87 1.87 0 008.01 2.5h1.365a.625.625 0 000-1.25zM9.375 6.25H5.51A1.87 1.87 0 003.75 5a1.87 1.87 0 00-1.76 1.25H.625a.625.625 0 000 1.25H1.99a1.87 1.87 0 001.76 1.25A1.87 1.87 0 005.51 7.5h3.865a.625.625 0 000-1.25z"
        fill="#333"
      />
    </Svg>
  );
}

export default SvgComponent;
